var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBulkImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.832 55.082H19.1655C10.6922 55.082 5 49.1393 5 40.2927V19.8738C5 11.0273 10.6922 5.08203 19.1655 5.08203H40.8345C49.3078 5.08203 55 11.0273 55 19.8738V40.2927C55 49.1393 49.3078 55.082 40.832 55.082",
    fill: "#F7D4D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1127 21.7697C28.1127 25.1947 25.3252 27.9822 21.9002 27.9822C18.4727 27.9822 15.6877 25.1947 15.6877 21.7697C15.6877 18.3447 18.4727 15.5547 21.9002 15.5547C25.3252 15.5547 28.1127 18.3447 28.1127 21.7697ZM48.5012 35.3012C49.0837 35.8662 49.5012 36.5112 49.7762 37.1987C50.6087 39.2787 50.1762 41.7787 49.2862 43.8387C48.2312 46.2912 46.2112 48.1437 43.6662 48.9537C42.5362 49.3162 41.3512 49.4712 40.1687 49.4712H19.2162C17.1312 49.4712 15.2862 48.9862 13.7737 48.0762C12.8262 47.5062 12.6587 46.1937 13.3612 45.3387C14.5362 43.9137 15.6962 42.4837 16.8662 41.0412C19.0962 38.2812 20.5987 37.4812 22.2687 38.1837C22.9462 38.4737 23.6262 38.9112 24.3262 39.3712C26.1912 40.6062 28.7837 42.3012 32.1987 40.4612C34.533 39.1848 35.8881 37.0006 37.0675 35.0995L37.0912 35.0612C37.1706 34.934 37.2493 34.8068 37.3278 34.68C37.7288 34.032 38.1238 33.3937 38.5712 32.8062C39.1262 32.0787 41.1862 29.8037 43.8487 31.4237C45.5462 32.4437 46.9737 33.8237 48.5012 35.3012Z",
    fill: "#D9272D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBulkImage);
export default __webpack_public_path__ + "static/media/icon-bulk-image.0be9dc48619467b9d87966e1aacd792b.svg";
export { ForwardRef as ReactComponent };